import { Spinner } from "react-bootstrap";

const LoadingSpinner = () => {
    return (
        <div className="d-flex align-items-center justify-content-center vh-100">
            <Spinner
                style={{ color: "var(--primary-color)" }}
                animation="border"
                role="status"
            ></Spinner>
        </div>
    );
};

export default LoadingSpinner;
